module.exports = {
    __esModule: true,
    default: function anonymous(props
/*``*/) {
var out='<div class="'+(props.styles.tooltipContainer)+'"></div>';return out;
} 
  };


//////////////////
// WEBPACK FOOTER
// ../node_modules/playable/dist/src/modules/ui/core/tooltip/templates/tooltipContainer.dot.js
// module id = 162
// module chunks = 0